<label
  [class]="{'mat-invalid': field?.formControl?.invalid ?? false}"
  [for]="field?.key"
  class="form-field standard{{ (field?.props?.required ?? false) ? ' required' : '' }}"
>
  {{ field?.props?.label }}
</label>
<editor
  [init]="init"
  [formControl]="formControl"
  [id]="field?.key?.toString()"
  [class.field-invalid]="formControl?.invalid && (!formControl?.pristine || formControl?.touched)"
></editor>
<div class="mat-mdc-form-field-subscript-wrapper mat-mdc-form-field-bottom-align">
  @if (formControl?.invalid && (!formControl?.pristine || formControl?.touched)) {
    <div class="mat-mdc-form-field-error-wrapper">
      <mat-error aria-atomic="true" class="mat-mdc-form-field-error mat-mdc-form-field-bottom-align" aria-live="polite">
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>
    </div>
  } @else {
    <div class="mat-mdc-form-field-hint-wrapper">
      <div class="mat-mdc-form-field-hint-spacer">{{ field.props.description }}</div>
    </div>
  }
</div>
